const WEB3FORMS_URL = 'https://api.web3forms.com/submit'
const WEB3FORMS_KEY = 'fefb6dca-a616-4c08-b8ed-e4b1ad2915e6'

interface FormPayload {
  subject: string
  [key: string]: string | number | boolean | undefined
}

export async function sendFormEmail(data: FormPayload): Promise<boolean> {
  try {
    const res = await fetch(WEB3FORMS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: WEB3FORMS_KEY,
        ...data,
      }),
    })
    const result = await res.json()
    return result.success === true
  } catch (err) {
    console.error('Form submission error:', err)
    return false
  }
}
